import lazyImporter from '@/utils/lazyImporter'

const orderRoute = {
  component: lazyImporter('View'),
  meta: { title: 'orders', icon: 'shopping_cart' },
  name: 'admin_order',
  path: '/order',
  redirect: { name: 'admin_order_list' },
  children: [
    {
      component: lazyImporter('order/OrderList'),
      meta: { title: 'orderList', hidden: true },
      name: 'admin_order_list',
      path: ''
    },
    {
      component: lazyImporter('order/OrderShow'),
      meta: { title: 'orderShow', hidden: true },
      name: 'admin_order_show',
      path: ':uuid',
      props: true
    }
  ]
}

export default orderRoute
